<div class="audio-player-container" [class.compact]="compact" [style.background-color]="backgroundColor" [style.color]="textColor">
  @if (title && showPlayer) {
    <div class="audio-player__title">
      {{title}}
    </div>
  }

  <div class="audio-player__wrapper" [class.player-inited]="!firstStart">
    @if (firstStart) {
      <div class="audio-player__start-button" [class.blue]="!showPlayer && !textColor" [style.background-color]="textColor ? 'transparent' : null" (click)="togglePlay()">
        <lib-icon [icon]="isPlaying ? 'pause' : 'play'"></lib-icon>
      </div>
    } @else {
      <div class="audio-player__playback-controls">
        @if (!preventTimeSeek) {
          <div class="audio-player__playback-controls-button" (click)="rewind()">
            <lib-icon icon="rewind"></lib-icon>
          </div>
        }
        <div class="audio-player__playback-controls-button" (click)="togglePlay()">
          <lib-icon [icon]="isPlaying ? 'pause' : 'play'"></lib-icon>
        </div>
        @if (!preventTimeSeek) {
          <div class="audio-player__playback-controls-button" (click)="fastForward()">
            <lib-icon icon="fast-forward"></lib-icon>
          </div>
        }
      </div>
    }
    @if (title && !showPlayer) {
      <div class="audio-player__title">
        {{title}}
      </div>
    }
    @if (!firstStart) {
      <div class="audio-player__playback-rate" (click)="togglePlaybackRate()">
        {{playbackRate}}X
      </div>
    }

    <div #waveform class="audio-wave" [class.init]="init" [class.hidden]="!showPlayer">
    </div>

    <ng-container *ngTemplateOutlet="durationTmp"></ng-container>
    @if (!firstStart) {
      <div class="audio-player__volume-control">
        <div class="audio-player__playback-controls-button" (click)="mute()">
          <lib-icon [icon]="isMuted ? 'speaker-simple-slash' : (volume > 50 ? 'speaker-simple-high' : 'speaker-simple-low')"></lib-icon>
        </div>
        <div class="audio-player__volume-control--popup">
          <mat-slider [min]="0" [max]="100" [step]="1" #ngSlider><input matSliderThumb [value]="volume" (change)="setVolume({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" /></mat-slider>
        </div>
      </div>
    }

    <div class="audio-player__wrapper--phone">
      <div class="audio-player__wrapper--phone-section">
        @if (firstStart) {
          <div class="audio-player__start-button" [class.blue]="!showPlayer && !textColor" [style.background-color]="textColor ? 'transparent' : null" (click)="togglePlay()">
            <lib-icon [icon]="isPlaying ? 'pause' : 'play'"></lib-icon>
          </div>
        } @else {
          <div class="audio-player__playback-controls">
            @if (!preventTimeSeek) {
              <div class="audio-player__playback-controls-button" (click)="rewind()">
                <lib-icon icon="rewind"></lib-icon>
              </div>
            }
            <div class="audio-player__playback-controls-button" (click)="togglePlay()">
              <lib-icon [icon]="isPlaying ? 'pause' : 'play'"></lib-icon>
            </div>
            @if (!preventTimeSeek) {
              <div class="audio-player__playback-controls-button" (click)="fastForward()">
                <lib-icon icon="fast-forward"></lib-icon>
              </div>
            }
          </div>
        }
        @if (!firstStart) {
          <div class="audio-player__playback-rate" (click)="togglePlaybackRate()">
            {{playbackRate}}X
          </div>
        }
      </div>
      <div class="audio-player__wrapper--phone-section">
        <ng-container *ngTemplateOutlet="durationTmp"></ng-container>
        @if (!firstStart) {
          <div class="audio-player__volume-control">
            <div class="audio-player__playback-controls-button" (click)="mute()">
              <lib-icon [icon]="isMuted ? 'speaker-simple-slash' : (volume > 50 ? 'speaker-simple-high' : 'speaker-simple-low')"></lib-icon>
            </div>
            <div class="audio-player__volume-control--popup">
              <mat-slider [min]="0" [max]="100" [step]="1" #ngSlider><input matSliderThumb [value]="volume" (change)="setVolume({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" /></mat-slider>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>





<ng-template #durationTmp>
  <div class="audio-player__duration">{{remainingTimeString}}</div>
</ng-template>

